import { FC, Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Login from "@screens/login";
import FailedPayment from "@screens/payment-fail/fail-payment.component";
import { retry } from "@utils/general";
import RegisterNew from "@screens/register-new/register-new.component";
import { PaymentModalInvoiceUnbound } from "@global/payment-modal/payment-modal-invoice-unbound.component";

const SuccessPayment = lazy(() =>
  retry(() => import("../../screens/success-payment/success-payment.component"))
);
const ForgotPassword = lazy(() =>
  retry(() => import("../../screens/forgot-password"))
);
const ResetPassword = lazy(() =>
  retry(() => import("../../screens/reset-password"))
);

const ResetPasswordOld = lazy(() =>
  retry(
    () => import("../../screens/reset-password/reset-password.component-old")
  )
);

const DefaultRootRoutes: FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<RegisterNew />} />
      <Route path="/invoice-billing" element={<PaymentModalInvoiceUnbound />} />

      <Route
        path="/payment-success"
        element={
          <Suspense fallback="...Is loading">
            <SuccessPayment />
          </Suspense>
        }
      />
      <Route
        path="/payment-fail"
        element={
          <Suspense fallback="...Is loading">
            <FailedPayment />
          </Suspense>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <Suspense fallback="...Is loading">
            <ForgotPassword />
          </Suspense>
        }
      />
      <Route
        path="/forgot-password-force"
        element={
          <Suspense fallback="...Is loading">
            <ForgotPassword isForcePassword={true} />
          </Suspense>
        }
      />
      <Route
        path="/reset-password/:id/:type"
        element={
          <Suspense fallback="...Is loading">
            <ResetPasswordOld />
          </Suspense>
        }
      />
      <Route
        path="/reset-password-new/:token"
        element={
          <Suspense fallback="...Is loading">
            <ResetPassword />
          </Suspense>
        }
      />
      <Route path="/" element={<Navigate to="/login" />} />

      <Route path="*" element={<Login />} />
    </Routes>
  );
};

export default DefaultRootRoutes;
